const INITIALIZE_USER = 'Initialize user'
const LOGIN = 'Login'
const LOGIN_SUCCESSFUL = 'Login successful'
const LOGIN_FAILURE = 'Login failure'
const LOGOUT = 'Logout'
const SET_HAS_SEEN_INTRO = 'Set has seen intro'

export default {
  INITIALIZE_USER,
  LOGIN,
  LOGIN_SUCCESSFUL,
  LOGIN_FAILURE,
  LOGOUT,
  SET_HAS_SEEN_INTRO
}



// WEBPACK FOOTER //
// ./src/app/reducers/constants/authConstants.js